import type { Me } from '@myrewards/contracts';

type DiagnosticIdentity = Pick<Me, 'roles'> & Partial<Pick<Me, 'preview'>>;

/**
 * Live System Admins only: sample Preview never inspects diagnostics. A tester acting as a System
 * Admin in Preview as has that person's access (APP-122 §10).
 */
export function canUseSystemDiagnostics(me: DiagnosticIdentity): boolean {
  return me.preview == null && me.roles.some((role) => role.role === 'system_admin');
}
